export const initialInLevelState: TVDLInLevelState = {
  type: 'default',
  title: null,
  unresolvedURL: null,
  resolvedURL: null,
  isEdit: false,
  haveBackButton: false,
  isNotEditable: true
};

export type TVDLInLevelState =
  | {
      type: 'default';
      title: null;
      resolvedURL: null;
      unresolvedURL: null;
      isEdit: boolean;
      haveBackButton: false;
      isNotEditable?: boolean;
    }
  | {
      type: 'event_plan';
      title: 'План мероприятий';
      resolvedURL: null;
      unresolvedURL: null;
      isEdit: boolean;
      haveBackButton: true;
      isNotEditable?: boolean;
    }
  | {
      type: 'iframe';
      title: string;
      resolvedURL: string;
      unresolvedURL: string;
      isEdit: null;
      haveBackButton: true;
      isNotEditable?: boolean;
    };
